<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div v-show="$route.path == '/Report/ProduceProducts'" class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันที่เริ่มต้น:</label>
                  <div class="input-group date">
                    <input readonly type="text" class="form-control" placeholder="(วว/ดด/ปปปป)" id="rePpJobDateStart"
                      name="rePpJobDateStart" ref="rePpJobDateStart" />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">วันที่สิ้นสุด:</label>
                  <div class="input-group date">
                    <input readonly type="text" class="form-control" placeholder="(วว/ดด/ปปปป)" id="rePpJobDateEnd"
                      name="rePpJobDateEnd" ref="rePpJobDateEnd" />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>เลขที่เอกสาร:</label>
                  <textarea v-model="rePpJobNumber" type="text" class="form-control" rows="1"
                    placeholder="ค้นหาจาก เลขที่เอกสาร" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>อายุน้ำเบียร์คงเหลือ:</label>
                  <input v-model="rePpRemainingDays" type="number" class="form-control"
                    placeholder="กรุณาระบุอายุน้ำเบียร์คงเหลือ" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>BARCODE:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePpBarcode'"
                    :name="'rePpBarcode'"
                    :select2-options="rePpBarcodeOptions"
                    multiple
                    v-model="rePpBarcode"
                    ref="rePpBarcodeSelect2"
                  ></select2> -->
                  <input v-model="rePpBarcode" type="text" class="form-control"
                    placeholder="กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>รหัสทรัพย์สิน(เบียร์สด):</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePpDepartmentMaterialCode'"
                    :name="'rePpDepartmentMaterialCode'"
                    :select2-options="rePpDepartmentMaterialCodeOptions"
                    v-model="rePpDepartmentMaterialCode"
                    ref="rePpDepartmentMaterialCodeSelect2"
                    multiple
                  ></select2> -->

                  <treeselect v-model="rePpDepartmentMaterialCode" :multiple="true"
                    :load-options="LoadrePpDepartmentMaterialCodeOptions" :async="true" v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา" placeholder="กรุณาเลือก" :cacheOptions="false" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>หมวดสินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePpProductGroup'"
                    :name="'rePpProductGroup'"
                    :select2-options="rePpProductGroupOptions"
                    multiple
                    v-model="rePpProductGroupOptions"
                  ></select2> -->
                  <treeselect v-model="rePpProductGroup" :multiple="true" :options="rePpProductGroupOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทสินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePpProductType'"
                    :name="'rePpProductType'"
                    :select2-options="rePpProductTypeOptions"
                    multiple
                    v-model="rePpProductType"
                  ></select2> -->
                  <treeselect v-model="rePpProductType" :multiple="true" :options="rePpProductTypeOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePpMaterialCode'"
                    :name="'rePpMaterialCode'"
                    :select2-options="rePpMaterialCodeOptions"
                    multiple
                    v-model="rePpMaterialCode"
                  ></select2> -->
                  <treeselect v-model="rePpMaterialCode" :multiple="true" :options="rePpMaterialCodeOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>แบรนด์:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePpProductBrand'"
                    :name="'rePpProductBrand'"
                    :select2-options="rePpProductBrandOptions"
                    multiple
                    v-model="rePpProductBrand"
                  ></select2> -->
                  <treeselect v-model="rePpProductBrand" :multiple="true" :options="rePpProductBrandOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ดำเนินการโดย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePpByUser'"
                    :name="'rePpByUser'"
                    :select2-options="rePpByUserOptions"
                    multiple
                    v-model="rePpByUser"
                  ></select2> -->
                  <treeselect v-model="rePpByUser" :multiple="true" :options="rePpByUserOptions" :clear-on-select="true"
                    placeholder="กรุณาเลือก" />
                </div>
              </div>

              <div v-show="this.$root.canShow([''])" class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>โรงงานที่ผลิต:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePpPlant'"
                    :name="'rePpPlant'"
                    :select2-options="rePpPlantOptions"
                    multiple
                    v-model="rePpPlant"
                  ></select2> -->
                  <treeselect v-model="rePpPlant" :multiple="true" :options="rePpPlantOptions" :clear-on-select="true"
                    placeholder="กรุณาเลือก" />
                </div>
              </div>
            </div>

            <div class="row mb-3" v-if="this.$root.canShow(['BR_REPORT'])">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button type="reset" class="btn btn-secondary" @click="formReset">
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button class="btn btn-outline-primary" @click="exportProduceProducts" type="submit">
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="produceProductTable" style="width:100%">
                <thead>
                  <tr>
                    <th class="all text-right" colspan="18">
                      ข้อมูล ณ วันที่ {{ rePpDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">ลำดับ</th>
                    <th class="all text-center">เลขที่เอกสาร</th>
                    <th class="all text-center">วันที่เอกสาร</th>
                    <th class="all text-center">วันที่สแกน</th>
                    <th class="all text-center">เดือน</th>
                    <th class="all text-center">ปี</th>
                    <th class="all text-center">ดำเนินการโดย</th>
                    <th class="all text-center">โรงงานที่ผลิต</th>
                    <th class="all text-center">อายุน้ำเบียร์ (เดือน)</th>
                    <th class="all text-center">อายุน้ำเบียร์คงเหลือ (วัน)</th>
                    <th class="all text-center">วันหมดอายุน้ำเบียร์</th>
                    <th class="all text-center">BARCODE</th>
                    <th class="all text-center">รหัสทรัพย์สิน(เบียร์สด)</th>
                    <th class="all text-center">หมวดหมู่สินค้า</th>
                    <th class="all text-center">ประเภทสินค้า</th>
                    <th class="all text-center">ชื่อสินค้า</th>
                    <th class="all text-center">แบรนด์</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function () {
    var self = this;

    return {
      rePpIsInitial: true,
      rePpDateReq: null,
      rePpJobDateStart: null,
      rePpJobDateEnd: null,
      rePpJobNumber: null,
      rePpRemainingDays: null,
      rePpBarcode: null,
      rePpDepartmentMaterialCode: [],
      rePpNFC: [],
      rePpProductGroup: [],
      rePpProductType: [],
      rePpMaterialCode: [],
      rePpProductBrand: [],
      rePpPlant: [],
      rePpByUser: [],
      rePpBarcodeOptions: [],
      // rePpBarcodeOptions: {
      //   placeholder: "กรุณาเลือกBarcode",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2BarcodeAll",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePpDepartmentMaterialCodeOptions: [],
      // rePpDepartmentMaterialCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกรหัสทรัพย์สินเบียร์สด",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2DepartmentMaterial",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePpNFCOptions: [],
      // rePpNFCOptions: {
      //   placeholder: "กรุณาเลือก NFCCode",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2NFC",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePpProductGroupOptions: [],
      // rePpProductGroupOptions: {
      //   placeholder: "กรุณาเลือกหมวดสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductGroup/Select2ProductGroup",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePpProductTypeOptions: [],
      // rePpProductTypeOptions: {
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePpByUserOptions: [],
      // rePpByUserOptions: {
      //   placeholder: "กรุณาเลือกดำเนินการโดย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/ProduceProducts/Select2ByUser",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePpPlantOptions: [],
      // rePpPlantOptions: {
      //   placeholder: "กรุณาเลือกโรงงานที่ผลิต",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Plant/Select2SearchPlant",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePpProductBrandOptions: [],
      // rePpProductBrandOptions: {
      //   placeholder: "กรุณาเลือกแบรนด์สินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2SearchBrandExistProduct",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePpMaterialCodeOptions: [],
      // rePpMaterialCodeOptions: {
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
    };
  },
  methods: {
    formReset: function (e) {
      let self = this;
      self.rePpJobDateStart = null;
      self.rePpJobDateEnd = null;
      self.rePpJobNumber = null;
      self.rePpRemainingDays = null;
      self.rePpBarcode = null;
      self.rePpDepartmentMaterialCode = [];
      self.rePpNFC = [];
      self.rePpProductGroup = [];
      self.rePpProductType = [];
      self.rePpMaterialCode = [];
      self.rePpProductBrand = [];
      self.rePpPlant = [];
      self.rePpByUser = [];

      $("#rePpJobDateStart")
        .val("")
        .trigger("change");

      $("#rePpJobDateEnd")
        .val("")
        .trigger("change");

      $("#rePpBarcode")
        .val("")
        .trigger("change");

      $("#rePpDepartmentMaterialCode")
        .val("")
        .trigger("change");

      $("#rePpProductGroup")
        .val("")
        .trigger("change");

      $("#rePpProductType")
        .val("")
        .trigger("change");

      $("#rePpMaterialCode")
        .val("")
        .trigger("change");

      $("#rePpProductBrand")
        .val("")
        .trigger("change");

      $("#rePpPlant")
        .val("")
        .trigger("change");

      $("#rePpByUser")
        .val("")
        .trigger("change");

      //this.formSubmit(e);
    },
    formSubmit: function (e) {
      let self = this;

      if (!self.rePpJobDateStart && self.rePpJobDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่เริ่มต้น", "warning");
        return false;
      } else if (self.rePpJobDateStart && !self.rePpJobDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่สิ้นสุด", "warning");
        return false;
      }

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      let status = null;
      // if(self.rePpDepartmentMaterialCode !=null){
      //   status = $("#rePpDepartmentMaterialCode").text();
      //   console
      // }

      e.preventDefault();
      var table = $("#produceProductTable").DataTable();
      table.draw();
    },
    exportProduceProducts: function (e) {
      e.preventDefault();
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportProduceProducts",
        responseType: "arraybuffer",
        data: {
          JobNumber: self.rePpJobNumber,
          JobDateStart:
            self.rePpJobDateStart != null
              ? self.rePpJobDateStart.format("DD/MM/YYYY")
              : self.rePpJobDateStart,
          JobDateEnd:
            self.rePpJobDateEnd != null
              ? self.rePpJobDateEnd.format("DD/MM/YYYY")
              : self.rePpJobDateEnd,
          RemainingDays: self.rePpRemainingDays,
          BarcodeNo: self.rePpBarcode,
          DepartmentMaterialCode: self.rePpDepartmentMaterialCode,
          NFCCode: self.rePpNFC,
          ProductGroup: self.rePpProductGroup,
          ProductType: self.rePpProductType,
          MaterialCode: self.rePpMaterialCode,
          ProductBrand: self.rePpProductBrand,
          ByUserId: self.rePpByUser,
          OriginPlantCode: self.rePpPlant,
          IsInitial: self.rePpIsInitial,
        },
      })
        .then(function (response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function (error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function () {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    // LoadrePpBarcodeOptions: function (e) {
    //   var self = this;
    //   axios
    //     .get("/Api/Barcode/Select2BarcodeAll", {
    //       params: {
    //         page: 1,
    //         all: true,
    //       },
    //     })
    //     .then(function (response) {
    //       if (response.status == 200) {
    //         var data = response.data.results;
    //         data.forEach((element) => {
    //           self.rePpBarcodeOptions.push({
    //             id: element.id,
    //             label: element.text,
    //           });
    //         });
    //       }
    //     })
    //     .catch(function (error) { });
    // },
    LoadrePpDepartmentMaterialCodeOptions({ action, searchQuery, callback }) {
      var self = this;
      self.rePpDepartmentMaterialCodeOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Barcode/Select2DepartmentMaterial", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function (response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.rePpDepartmentMaterialCodeOptions = [];
              data.forEach((element) => {
                self.rePpDepartmentMaterialCodeOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.rePpDepartmentMaterialCodeOptions);
          })
          .catch(function (error) { });
      }
    },
    LoadrePpNFCOptions({ action, searchQuery, callback }) {
      var self = this;
      self.rePpNFCOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Barcode/Select2NFC", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function (response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.rePpNFCOptions = [];
              data.forEach((element) => {
                self.rePpNFCOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.rePpNFCOptions);
          })
          .catch(function (error) { });
      }
    },
    LoadrePpProductGroupOptions: function (e) {
      var self = this;
      axios
        .get("/Api/ProductGroup/Select2ProductGroup", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePpProductGroupOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadrePpProductTypeOptions: function (e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePpProductTypeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadrePpByUserOptions: function (e) {
      var self = this;
      axios
        .get("/Api/Report/ProduceProducts/Select2ByUser", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePpByUserOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadrePpPlantOptions: function (e) {
      var self = this;
      axios
        .get("/Api/Plant/Select2SearchPlant", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePpPlantOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadrePpProductBrandOptions: function (e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePpProductBrandOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadrePpMaterialCodeOptions: function (e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePpMaterialCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    ClearAfterselect: function () {
      $(`[class="vue-treeselect__input"]`).val("");
    }
  },
  async mounted() {
    let self = this;

    // self.LoadrePpBarcodeOptions();
    self.LoadrePpProductGroupOptions();
    self.LoadrePpProductTypeOptions();
    self.LoadrePpByUserOptions();
    self.LoadrePpPlantOptions();
    self.LoadrePpProductBrandOptions();
    self.LoadrePpMaterialCodeOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.rePpDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.rePpJobDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.rePpJobDateStart).on("changeDate", function (e) {
      self.rePpJobDateStart = moment(e.date);
    });

    $(self.$refs.rePpJobDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.rePpJobDateEnd).on("changeDate", function (e) {
      self.rePpJobDateEnd = moment(e.date);
    });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#produceProductTable");
    // begin first table
    table
      .DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/ProduceProducts",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function (request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function (d) {
            self.isShowFooter = false;
            self.TotalAmount = 0;

            let jsonSearch = {
              JobNumber: self.rePpJobNumber,
              JobDateStart:
                self.rePpJobDateStart != null
                  ? self.rePpJobDateStart.format("DD/MM/YYYY")
                  : self.rePpJobDateStart,
              JobDateEnd:
                self.rePpJobDateEnd != null
                  ? self.rePpJobDateEnd.format("DD/MM/YYYY")
                  : self.rePpJobDateEnd,
              RemainingDays: self.rePpRemainingDays,
              BarcodeNo: self.rePpBarcode,
              DepartmentMaterialCode: self.rePpDepartmentMaterialCode,
              NFCCode: self.rePpNFC,
              ProductGroup: self.rePpProductGroup,
              ProductType: self.rePpProductType,
              MaterialCode: self.rePpMaterialCode,
              ProductBrand: self.rePpProductBrand,
              ByUserId: self.rePpByUser,
              OriginPlantCode: self.rePpPlant,
              IsInitial: self.rePpIsInitial,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },
        // Order settings
        order: [[2, "desc"]],
        columns: [
          {
            data: "jobDate",
            className: "text-center",
            render: function (data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          },
          { data: "jobNumber", className: "text-center" },
          {
            data: "jobDate",
            className: "text-center",
            render: function (data, type, full, meta) {
              return full.jobDateString;
            },
          },
          { data: "jobDateScanString", className: "text-center" },
          { data: "monthScanString", className: "text-center" },
          { data: "yearScan", className: "text-center" },
          { data: "displayName", className: "text-center" },
          { data: "originPlantName", className: "text-center" },
          { data: "beerMonths", className: "text-center" },
          {
            data: "remainingDays",
            className: "text-center",
            render: function (data, type, full, meta) {
              if (data <= 0) {
                return "หมดอายุ";
              } else {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              }
            },
          },
          {
            data: "beerExpireDate",
            className: "text-center",
            render: function (data, type, full, meta) {
              return full.beerExpireDateString;
            },
          },
          { data: "barcodeNoOld", className: "text-center" },
          { data: "departmentMaterialCode", className: "text-center" },
          { data: "productGroupName", className: "text-center" },
          { data: "productTypeName", className: "text-center" },
          { data: "materialName", className: "text-center" },
          { data: "productBrandName", className: "text-center" },
        ],
        rowCallback: function (row, data, index) {
          if (data.remainingDays <= 0) {
            $(row)
              .find("td:eq(8)")
              .css("color", "white");
            $(row)
              .find("td:eq(8)")
              .css("background-color", "#EB355E");
          }
        },
        //
        drawCallback: function (settings) {
          self.rePpIsInitial = false;
          self.rePpDateReq = moment().format("DD/MM/YYYY h:mm a");

          var allPage = table.DataTable().page.info().pages;
          var currentPage = table.DataTable().page.info().page + 1;

          if (allPage == currentPage) {
            self.isShowFooter = true;
            self.TotalAmount = settings.json.data[0].totalAmount;
          }
        },
      })
      .on("preXhr.dt", function () {
        KTApp.block(self.$refs.form, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("xhr.dt", function () {
        KTApp.unblock(self.$refs.form);
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        // var t = table.DataTable();
        // var page = t.page.info().start + 1;
        // t.column(0, {}).nodes().each( function (cell, i) {
        //     cell.innerHTML = i+page;
        // } );
      });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// App/Components/Report/ProduceProducts.vue